import React from 'react';

import {connect} from 'react-redux';
import {loginByToken, logoutAgency, logOutPassenger} from '../../actions/authenticationActions';
import If from "../../components/If";
import TextInputWithLabel from '../../components/TextInputWithLabel';
import {setStore} from '../../actions/storeActions';
import {getHubBaseUrl} from "../../utils/configUtils";
import { navigate } from '../../utils/navigationUtils';

class AgencyTokenLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginInProgress: false,
            storeId: "",
            errors: {},
            loginFailed: false,
        };
    }

    //--

    componentDidMount() {
        logoutAgency();
        logOutPassenger();

        this.setState({
            storeId: this.props.storeId,
        });
    }

    //--

    validateForm = (e) => {
        e.preventDefault();

        let errors = {};

        if (!this.state.storeId) {
            errors.storeId = "Please enter your Store Number";
        }

        this.setState({
            errors: errors,
        });

        if (Object.keys(errors).length === 0) {
            this._onLogin();
        }
    };

    render() {
        return (
            <div className="container mx-auto">
                <If test={!this.state.loginInProgress  && !this.state.loginFailed}>
                    <form className="mt-8" onSubmit={(e) => this.validateForm(e)}>
                        <div className="my-4">
                            <TextInputWithLabel
                                label="Store Number"
                                type="text"
                                value={this.state.storeId}
                                _onChange={value => this.setState({storeId: value})}
                                placeholder=""
                                errorMessage={this.state.errors.storeId}
                            />
                        </div>

                        <div className="my-4">
                            <input className="inline-block w-1/2 sm:w-30 action-button action-button-enabled"
                                   type="submit"
                                   value="Login"/>
                        </div>

                    </form>
                </If>

                <If test={this.state.loginInProgress}>
                    <div>
                        <h2>
                            Please wait...
                        </h2>
                    </div>
                </If>

                <If test={this.state.loginFailed}>
                    <div className="my-8 text-xl">
                        Unable to log in with the given credentials, please try again by visiting the{' '}
                        <a className="underline text-primary-dark" href={`${getHubBaseUrl()}authentication/SingleSignOnServlet`}>
                            login page.
                        </a>
                    </div>
                </If>
            </div>
        );
    }

    //--

    async _onLogin() {
        this.setState({loginInProgress: true});
        this.props.setStore(this.state.storeId);
        const valid = await this.props.loginByToken(this.props.match.params.token, this.state.storeId);
        if (valid) {
            navigate('/itinerary');
        }
        else {
            this.setState({
                loginInProgress: false,
                loginFailed: true,
            });
        }
    }
}

function mapStateToProps(state) {
    return {
        storeId: state.store.id,
    };
}

export default connect(mapStateToProps, {
    loginByToken,
    setStore,
})( AgencyTokenLogin);